import { Map, OrderedMap, fromJS } from 'immutable';
import { isEmpty } from 'lodash';
import UserConstants from 'Shared/constants/Users.constants';
import CommentsConstants from 'Shared/constants/Comments.constants';
import GoalsConstants from 'Shared/constants/Goals.constants';
import MeetingItemsConstants from 'Shared/constants/MeetingItems.constants';
import FeedbacksConstants from 'Shared/constants/Feedbacks.constants';
import WorkspaceItemCommentsConstants from 'Shared/constants/WorkspaceItemComments.constants';
import WorkspaceMeetingModeConstants from 'Shared/constants/WorkspaceMeetingMode.constants';
import WorkspaceRecentUpdatesConstants from '../constants/WorkspaceRecentUpdates.constants';
import ReviewsConstants from 'Shared/constants/Reviews.constants';
import ReviewFormsConstants from 'Shared/constants/ReviewForms.constants';
import UserSuggestionsConstants from 'Shared/constants/UserSuggestions.constants';
import ReviewTemplatesConstants from 'Shared/constants/ReviewTemplates.constants';
import ReviewCyclesConstants from 'Shared/constants/ReviewCycles.constants';

const initialState = Map({
  [UserConstants.State.USERS_BY_USER_ID]: OrderedMap(),
});

export const UsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case UserConstants.Actions.FETCH_USER_BY_ID_SUCCESS:
    case UserConstants.Actions.UPDATE_USER_SUCCESS:
    case UserConstants.Actions.UPDATE_USER_PHOTO_SUCCESS:
    case CommentsConstants.Actions.CREATE_COMMENT_SUCCESS:
    case GoalsConstants.Actions.FETCH_SINGLE_GOAL_SUCCESS:
    case GoalsConstants.Actions.FETCH_GOALS_SUCCESS:
    case MeetingItemsConstants.Actions.FETCH_MEETING_ITEMS_SUCCESS:
    case MeetingItemsConstants.Actions.FETCH_SINGLE_MEETING_ITEMS_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_HIGH_PRIORITY_SUCCESS:
    case MeetingItemsConstants.Actions.CONVERT_DISCUSSION_TOPIC_AND_ACTION_ITEM:
    case MeetingItemsConstants.Actions.UPDATE_COMPLETE_STATUS_SUCCESS:
    case GoalsConstants.Actions.UPDATE_GOAL_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_ASSIGNEE_SUCCESS:
    case MeetingItemsConstants.Actions.CREATE_ASANA_TASK_SUCCESS:
    case WorkspaceItemCommentsConstants.Actions.FETCH_WORKSPACE_ITEM_COMMENTS_SUCCESS:
    case WorkspaceItemCommentsConstants.Actions.UPDATE_WORKSPACE_ITEM_COMMENT_SUCCESS:
    case WorkspaceItemCommentsConstants.Actions.CREATE_WORKSPACE_ITEM_COMMENT_SUCCESS:
    case FeedbacksConstants.Actions.FETCH_FEEDBACKS_SUCCESS:
    case FeedbacksConstants.Actions.CREATE_FEEDBACK_SUCCESS:
    case FeedbacksConstants.Actions.UPDATE_FEEDBACK_SUCCESS:
    case FeedbacksConstants.Actions.FETCH_SINGLE_FEEDBACK_SUCCESS:
    case FeedbacksConstants.Actions.FEEDBACKS_SYNC_SUCCESS:
    case WorkspaceMeetingModeConstants.Actions.FETCH_MEET_MODE_SUCCESS:
    case WorkspaceMeetingModeConstants.Actions.START_MEET_MODE_SUCCESS:
    case WorkspaceMeetingModeConstants.Actions.UPDATE_MEET_MODE_SUCCESS:
    case WorkspaceMeetingModeConstants.Actions.ACTION_CABLE_UPDATE_SUCCESS:
    case WorkspaceRecentUpdatesConstants.Actions.FETCH_RECENT_UPDATES_SUCCESS:
    case ReviewsConstants.Actions.FETCH_REVIEWS_SUCCESS:
    case ReviewsConstants.Actions.CREATE_REVIEW_SUCCESS:
    case ReviewFormsConstants.Actions.FETCH_REVIEW_FORMS_SUCCESS:
    case ReviewFormsConstants.Actions.CREATE_REVIEW_FORMS_SUCCESS:
    case ReviewFormsConstants.Actions.UPDATE_REVIEW_FORM_COMPILER_SUCCESS:
    case ReviewsConstants.Actions.FETCH_SINGLE_REVIEW_SUCCESS:
    case UserSuggestionsConstants.Actions.FETCH_USER_SUGGESTIONS_SUCCESS:
    case ReviewTemplatesConstants.Actions.FETCH_REVIEW_TEMPLATES_SUCCESS:
    case ReviewCyclesConstants.Actions.FETCH_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.LAUNCH_REVIEW_CYCLE_SUCCESS:
    case ReviewCyclesConstants.Actions.CREATE_REVIEWS_ON_REVIEW_CYCLE_SUCCESS:
    // this action is dispatched from the fetch members actionsto so that UsersSelectors can pull from this store
    // eslint-disable-next-line
    case 'GET_MEMBERS_RESPONSE_NEW_STORE':
      // is there is no data, json-api-normalizr will convert payload to
      // an empty object, we need to ensure it's not empty before trying to iterate over items
      if (isEmpty(action.payload)) {
        return state;
      }
      return state.updateIn([UserConstants.State.USERS_BY_USER_ID], (existing = OrderedMap()) =>
        existing.merge(
          Object.values(action.payload.user).map(item => {
            return [item.attributes.id, Map(fromJS(item.attributes))];
          })
        )
      );

    // the Workspace endpoint is not utilizing the JSSONAPI response
    // need to pull users out of the response to update the store
    case 'WORKSPACE_GET_RESPONSE':
      return state.updateIn([UserConstants.State.USERS_BY_USER_ID], (existing = OrderedMap()) => {
        return existing.merge(
          Object.values(action.data.users).map(item => {
            return [item.id, Map(fromJS(item))];
          })
        );
      });
    default:
      return state;
  }
};
